import Config from '../../config';
import {
  handleErrors,
  parseAsJson,
} from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';

export const fetchAccountMaps = async periodName => await fetch(
  Config.endpoints.FETCH_ACCOUNT_MAP
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching Accounts Maps failed' }))
  .then(parseAsJson);
//
export const importAccountMaps = async (AccountMaps, periodName) => await fetch(
  Config.endpoints.ADMIN_IMPORT_ACCOUNT_MAP,
  {
    method: 'POST',
    body: JSON.stringify({ AccountMaps, periodName }),
  }
)
  .then(handleErrors({ errorMessage: 'Importing Accounts Maps failed' }));

//
export const deleteAccountMap = async ({ periodName, bsmAccount, glAccount }) => await fetch(
  Config.endpoints.DELETE_ACCOUNT_MAP
    .replace(/:periodName/, periodName)
    .replace(/:bsmAccount/, bsmAccount)
    .replace(/:glAccount/, glAccount),
  {
    method: 'DELETE',
  }
)
  .then(handleErrors({ errorMessage: 'Deleting Account Map failed' }));
//
export const insertAccountMap = accountMap => fetch(
  Config.endpoints.INSERT_ACCOUNT_MAP,
  {
    method: 'POST',
    body: JSON.stringify(accountMap),
  }
)
  .then(handleErrors({ errorMessage: 'Inserting Account Map failed' }));
//
export const updateAccountMap = async ({ periodName, bsmAccount, glAccount }, accountMap) => await fetch(
  Config.endpoints.UPDATE_ACCOUNT_MAP
    .replace(/:periodName/, periodName)
    .replace(/:bsmAccount/, bsmAccount)
    .replace(/:glAccount/, glAccount),
  {
    method: 'PUT',
    body: JSON.stringify(accountMap),
  }
)
  .then(handleErrors({ errorMessage: 'Updating Account Map failed' }));
